var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { useLanguage } from '@base/LanguageProvider';
import { DataType, DefaultFormatType, ExpressionType, InternalTagType, RollupType, TagType, } from '@common/api';
import FSButton from '@components/FSButton';
import * as baobab from '@data/baobab/baobab';
import { useExpSearchables } from '@data/hooks/expSearchables';
import { backpropApi, evaluatorApi } from '@data/rest/api';
import { useTagActions } from '@data/tag/tagActions';
import { useTagContext } from '@data/tag/tagContext';
import { useTableTagRelationsActions } from '@data/tag/tagRelationActions';
import BorderdContainer from '@main/conf/managers/BorderedContainer';
import { validateExpression } from '@shared/expression/ExpActions';
import ExpEditor, { getEditorState, getExpErrorString } from '@shared/expression/ExpEditor';
import { checkExpression } from '@shared/expression/parser';
import { CheckBox } from '@shared/input/CheckBox';
import SelectInput from '@shared/input/SelectInput';
import SelectTag from '@shared/input/SelectTag';
import TextArea from '@shared/input/TextArea';
import TextInput from '@shared/input/TextInput';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import Manager from '@shared/modal/Manager';
import Modal from '@shared/modal/Modal';
import ModalFooter from '@shared/modal/ModalFooter';
import ModalHeader from '@shared/modal/ModalHeader';
import Tags from '@shared/tags/Tags';
import TagsEditWithDropdown from '@shared/tags/TagsEditWithDropdown';
import { FormField, FormFieldErrorHelp, FormFieldLabel } from '@styled/Form';
import { TemplatedGrid } from '@styled/Grid';
import { ModalBody } from '@styled/Modal';
import { Color, ExpressionBlockTypes } from '@util/enums';
import { downloadFile } from '@util/helpers';
import { isExcelDateFormat, isExcelPercentFormat, isValidFormat } from '@util/number';
//@ts-ignore
import { useRoot } from 'baobab-react/hooks';
import { Editor } from 'draft-js';
import React, { useMemo, useRef, useState } from 'react';
import { FiRefreshCcw } from 'react-icons/fi';
import { MdRemove } from 'react-icons/md';
import FSFormSection from '../../../components/FSFormSection';
import { useSheetRowsById } from '../../../data/sheetRow/sheetRowHooks';
import { getConnectedAccTagsWithDiffDimensions, getFixatedTagsConnectedToDimensionsMap, getTagTypeName, } from '../../../data/tag/tagUtil';
import { isAccountTag } from '../../../data/tag/types';
import { warning } from '../../../util/message';
import Tag from '../../tags/Tag';
var PREDEFINED_FORMATS = (_a = {},
    _a[DefaultFormatType.Date] = ['dd.mm.yyyy.', 'dd-mm-yyyy.', 'dd/mm/yyyy', 'yyyy.mm.dd.', 'yyyy-mm-dd', 'yyyy/mm/dd'],
    _a[DefaultFormatType.Currency] = [
        '#,##0 "HRK"',
        '#,##0.00 "HRK"',
        '#,##0 "HRK";(#,##0) "HRK"',
        '#,##0.00 "HRK";(#,##0.00) "HRK"',
        '$#,##0',
        '$#,##0.00',
        '$#,##0;($#,##0)',
        '$#,##0.00;($#,##0.00)',
        '€#,##0',
        '€#,##0.00',
        '€#,##0;(€#,##0)',
        '€#,##0.00;(€#,##0.00)',
    ],
    _a[DefaultFormatType.Percentage] = ['#,##0%', '#,##0.00%', '#,##0%;(#,##0%);', '#,##0.00%;(#,##0.00%)'],
    _a[DefaultFormatType.Number] = ['#,##0.00', '#,##0', '#,##0.00;(#,##0.00)', '#,##0;(#,##0)'],
    _a[DefaultFormatType.Custom] = [],
    _a);
var Wrap = function (props) {
    var Root = useRoot(baobab.root);
    return (React.createElement(Root, null,
        React.createElement(TagModal, __assign({}, props))));
};
var emptyTag = {
    id: 0,
    name: '',
    description: '',
    type: TagType.Dimension,
    topDownEnabled: false,
    rollupType: RollupType.Sum,
    jsonData: null,
    ParentId: null,
    expression: '',
    connectedTagIds: [],
    dimensionTagIds: [],
    active: true,
    order: 0,
    dataType: undefined,
    numberFormat: null,
    topDownMapping: null,
    optimizeCalculation: true,
    usedInTagIds: [],
    fromVersionTagId: undefined,
    toAccountTagId: undefined,
    toVersionTagId: undefined,
    readonly: undefined,
    calculateOnDemand: undefined,
    zConstraint: undefined,
};
var TagModal = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var _v = useLanguage(), L = _v.L, excelLocalizedDateFormat = _v.excelLocalizedDateFormat, excelLocalizedNumberFormat = _v.excelLocalizedNumberFormat;
    var editingTag = props.tag, _w = props.simpleMode, simpleMode = _w === void 0 ? false : _w;
    var searchables = useExpSearchables();
    var tagData = useTagContext().tagData;
    var editTag = useTagActions().editTag;
    var sheetRowsById = useSheetRowsById();
    var expRef = useRef(null);
    var topDownMappingRef = useRef(null);
    var targetTag = emptyTag;
    if (editingTag) {
        targetTag = __assign(__assign({}, editingTag), { topDownEnabled: (_a = editingTag.topDownEnabled) !== null && _a !== void 0 ? _a : false, connectedTagIds: (_b = editingTag.connectedTagIds) !== null && _b !== void 0 ? _b : [], dimensionTagIds: (_c = editingTag.dimensionTagIds) !== null && _c !== void 0 ? _c : [] });
    }
    var _x = __read(useState(targetTag), 2), tag = _x[0], setTag = _x[1];
    var _y = __read(useState({}), 2), invalid = _y[0], setInvalid = _y[1];
    var _z = __read(useState(false), 2), loading = _z[0], setLoading = _z[1];
    var _0 = __read(useState((_d = tag.numberFormat) === null || _d === void 0 ? void 0 : _d.type), 2), formatType = _0[0], setFormatType = _0[1];
    var _1 = __read(useState(false), 2), showAdvanced = _1[0], setShowAdvanced = _1[1];
    var _2 = __read(useState(false), 2), showExpressions = _2[0], setShowExpressions = _2[1];
    var onExportClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var dimensions, _a, _b, dimensionTagId, t, configuration, res;
        var e_1, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!tag.dimensionTagIds) {
                        return [2 /*return*/];
                    }
                    dimensions = [];
                    try {
                        for (_a = __values(tag.dimensionTagIds), _b = _a.next(); !_b.done; _b = _a.next()) {
                            dimensionTagId = _b.value;
                            t = tagData.tagById[dimensionTagId];
                            if (!t || t.type !== TagType.Table) {
                                continue;
                            }
                            dimensions.push({
                                type: 'DIMENSION',
                                name: t.name,
                                dimensionTagId: t.id,
                            });
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    configuration = {
                        format: 'csv',
                        columns: __spreadArray(__spreadArray([], __read(dimensions), false), [
                            {
                                type: 'ACCOUNT',
                                name: tag.name,
                                accountTagId: tag.id,
                                filterTagIds: [],
                            },
                        ], false),
                    };
                    return [4 /*yield*/, evaluatorApi.exportDatabase(JSON.stringify(configuration))];
                case 1:
                    res = _d.sent();
                    downloadFile(res, tag.name.split(' ').join('_').toLowerCase() + '.csv');
                    return [2 /*return*/];
            }
        });
    }); };
    var DATA_TYPE_OPTIONS = Object.entries(DataType).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return ({
            label: L(key),
            value: value,
        });
    });
    var FORMAT_OPTIONS = __spreadArray([
        { label: L('Global formatting'), value: null }
    ], __read(Object.entries(DefaultFormatType).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return ({
            label: L(key),
            value: value,
        });
    })), false);
    var ROLLUP_TYPES = [
        { label: L('None'), value: RollupType.None },
        { label: L('Sum'), value: RollupType.Sum },
        { label: L('Average'), value: RollupType.Average },
        { label: L('Closing state'), value: RollupType.ClosingState },
        { label: L('Beginning state'), value: RollupType.BeginningState },
        { label: L('Formula'), value: RollupType.Formula },
    ];
    var initialReverseConnectedTagIds = useMemo(function () {
        var arr = [];
        if (tag.id) {
            tagData.tags.forEach(function (t) {
                var _a;
                if ((_a = t.connectedTagIds) === null || _a === void 0 ? void 0 : _a.includes(tag.id)) {
                    arr.push(t.id);
                }
            });
        }
        return arr;
    }, [tag, tagData]);
    var _3 = __read(useState(initialReverseConnectedTagIds), 2), reverseConnectedTagIds = _3[0], setReverseConnectedTagIds = _3[1];
    // initial dimension connection
    var _4 = useTableTagRelationsActions(), addTableRelationConnectedTag = _4.addTableRelationConnectedTag, removeTableRelationConnectedTag = _4.removeTableRelationConnectedTag;
    var relations = useMemo(function () {
        if (tag.type === TagType.Dimension) {
            return tag.ParentId ? tagData.relationsByTableTagId[tag.ParentId] : [];
        }
        else {
            return [];
        }
    }, [tag.ParentId, tagData.relationsByTableTagId]);
    var reverseRelations = useMemo(function () {
        if (tag.type === TagType.Dimension) {
            return tagData.relations.filter(function (relation) {
                if (relation.connectedTableTagId === tag.ParentId) {
                    return relation;
                }
            });
        }
        else {
            return [];
        }
    }, [tag.ParentId, tagData.relations]);
    var initialDimConnTags = useMemo(function () {
        var newDCT = [];
        relations === null || relations === void 0 ? void 0 : relations.forEach(function (r) {
            r.connections.map(function (c) {
                if (tag.id === c.dimensionTagId) {
                    newDCT.push(c.connectedDimensionTagId);
                }
            });
        });
        return newDCT;
    }, [relations]);
    var initialDimReverseConnTags = useMemo(function () {
        var newDRCT = [];
        reverseRelations === null || reverseRelations === void 0 ? void 0 : reverseRelations.forEach(function (r) {
            r.connections.map(function (c) {
                if (tag.id === c.connectedDimensionTagId) {
                    newDRCT.push(c.dimensionTagId);
                }
            });
        });
        return newDRCT;
    }, [reverseRelations]);
    var _5 = __read(useState(initialDimConnTags), 2), dimConnTags = _5[0], setDimConnTags = _5[1];
    var _6 = __read(useState(initialDimReverseConnTags), 2), dimReverseConnTags = _6[0], setDimReverseConnTags = _6[1];
    var updateDimConnections = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _loop_1, i, state_1, _loop_2, i, state_2, _loop_3, i, state_3, _loop_4, i, state_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!tag.id)
                        return [2 /*return*/];
                    _loop_1 = function (i) {
                        var dimConnTagId, dim, table_1, relation;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    dimConnTagId = dimConnTags[i];
                                    if (!!initialDimConnTags.includes(dimConnTagId)) return [3 /*break*/, 2];
                                    dim = tagData.tagById[dimConnTagId];
                                    table_1 = dim && dim.ParentId ? tagData.tagById[dim.ParentId] : null;
                                    if (!dim || !table_1) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    relation = relations === null || relations === void 0 ? void 0 : relations.find(function (r) {
                                        return r.connectedTableTagId === table_1.id;
                                    });
                                    if (!relation) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    return [4 /*yield*/, addTableRelationConnectedTag(relation.id, tag.id, dim.id)];
                                case 1:
                                    _b.sent();
                                    _b.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    };
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < dimConnTags.length)) return [3 /*break*/, 4];
                    return [5 /*yield**/, _loop_1(i)];
                case 2:
                    state_1 = _a.sent();
                    if (typeof state_1 === "object")
                        return [2 /*return*/, state_1.value];
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4:
                    _loop_2 = function (i) {
                        var iDimConnTagId, dim, table_2, relation;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    iDimConnTagId = initialDimConnTags[i];
                                    if (!!dimConnTags.includes(iDimConnTagId)) return [3 /*break*/, 2];
                                    dim = tagData.tagById[iDimConnTagId];
                                    table_2 = dim && dim.ParentId ? tagData.tagById[dim.ParentId] : null;
                                    if (!dim || !table_2) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    relation = relations === null || relations === void 0 ? void 0 : relations.find(function (r) {
                                        return r.connectedTableTagId === table_2.id;
                                    });
                                    if (!relation) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    return [4 /*yield*/, removeTableRelationConnectedTag(relation.id, tag.id, dim.id)];
                                case 1:
                                    _c.sent();
                                    _c.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    };
                    i = 0;
                    _a.label = 5;
                case 5:
                    if (!(i < initialDimConnTags.length)) return [3 /*break*/, 8];
                    return [5 /*yield**/, _loop_2(i)];
                case 6:
                    state_2 = _a.sent();
                    if (typeof state_2 === "object")
                        return [2 /*return*/, state_2.value];
                    _a.label = 7;
                case 7:
                    i++;
                    return [3 /*break*/, 5];
                case 8:
                    _loop_3 = function (i) {
                        var dimReverseConnTagId, dim, table_3, reverseRelation;
                        return __generator(this, function (_d) {
                            switch (_d.label) {
                                case 0:
                                    dimReverseConnTagId = dimReverseConnTags[i];
                                    if (!!initialDimReverseConnTags.includes(dimReverseConnTagId)) return [3 /*break*/, 2];
                                    dim = tagData.tagById[dimReverseConnTagId];
                                    table_3 = dim && dim.ParentId ? tagData.tagById[dim.ParentId] : null;
                                    if (!dim || !table_3) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    reverseRelation = reverseRelations === null || reverseRelations === void 0 ? void 0 : reverseRelations.find(function (r) {
                                        return r.tableTagId === table_3.id;
                                    });
                                    if (!reverseRelation) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    return [4 /*yield*/, addTableRelationConnectedTag(reverseRelation.id, dim.id, tag.id)];
                                case 1:
                                    _d.sent();
                                    _d.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    };
                    i = 0;
                    _a.label = 9;
                case 9:
                    if (!(i < dimReverseConnTags.length)) return [3 /*break*/, 12];
                    return [5 /*yield**/, _loop_3(i)];
                case 10:
                    state_3 = _a.sent();
                    if (typeof state_3 === "object")
                        return [2 /*return*/, state_3.value];
                    _a.label = 11;
                case 11:
                    i++;
                    return [3 /*break*/, 9];
                case 12:
                    _loop_4 = function (i) {
                        var iDimReverseConnTagId, dim, table_4, reverseRelation;
                        return __generator(this, function (_e) {
                            switch (_e.label) {
                                case 0:
                                    iDimReverseConnTagId = initialDimReverseConnTags[i];
                                    if (!!dimReverseConnTags.includes(iDimReverseConnTagId)) return [3 /*break*/, 2];
                                    dim = tagData.tagById[iDimReverseConnTagId];
                                    table_4 = dim && dim.ParentId ? tagData.tagById[dim.ParentId] : null;
                                    if (!dim || !table_4) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    reverseRelation = reverseRelations === null || reverseRelations === void 0 ? void 0 : reverseRelations.find(function (r) {
                                        return r.tableTagId === table_4.id;
                                    });
                                    if (!reverseRelation) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    return [4 /*yield*/, removeTableRelationConnectedTag(reverseRelation.id, dim.id, tag.id)];
                                case 1:
                                    _e.sent();
                                    _e.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    };
                    i = 0;
                    _a.label = 13;
                case 13:
                    if (!(i < initialDimReverseConnTags.length)) return [3 /*break*/, 16];
                    return [5 /*yield**/, _loop_4(i)];
                case 14:
                    state_4 = _a.sent();
                    if (typeof state_4 === "object")
                        return [2 /*return*/, state_4.value];
                    _a.label = 15;
                case 15:
                    i++;
                    return [3 /*break*/, 13];
                case 16: return [2 /*return*/];
            }
        });
    }); };
    var done = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _tag, invalid, index, idToEdit, tagToEdit, index, idToEdit, tagToEdit, err_1, invalidErr;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _tag = __assign({}, tag);
                    _tag.expression =
                        _tag.type === TagType.Account || _tag.type === TagType.Dimension
                            ? (_b = (_a = expRef.current).exportExpression) === null || _b === void 0 ? void 0 : _b.call(_a)
                            : null;
                    if (_tag.type === TagType.Account && _tag.topDownEnabled) {
                        _tag.topDownMapping = (_d = (_c = topDownMappingRef.current).exportExpression) === null || _d === void 0 ? void 0 : _d.call(_c);
                    }
                    else {
                        _tag.topDownMapping = null;
                    }
                    if (formatType) {
                        _tag.numberFormat = { format: (_e = _tag === null || _tag === void 0 ? void 0 : _tag.numberFormat) === null || _e === void 0 ? void 0 : _e.format, type: formatType };
                    }
                    return [4 /*yield*/, validate(_tag)];
                case 1:
                    invalid = _f.sent();
                    if (!(Object.keys(invalid).length === 0)) return [3 /*break*/, 16];
                    if (!tag.id) return [3 /*break*/, 15];
                    _f.label = 2;
                case 2:
                    _f.trys.push([2, 14, , 15]);
                    setLoading(true);
                    return [4 /*yield*/, editTag(_tag)];
                case 3:
                    _f.sent();
                    if (!(initialReverseConnectedTagIds !== reverseConnectedTagIds)) return [3 /*break*/, 11];
                    index = 0;
                    _f.label = 4;
                case 4:
                    if (!(index < reverseConnectedTagIds.length)) return [3 /*break*/, 7];
                    idToEdit = reverseConnectedTagIds[index];
                    if (!!initialReverseConnectedTagIds.includes(idToEdit)) return [3 /*break*/, 6];
                    tagToEdit = tagData.tagById[idToEdit];
                    tagToEdit.connectedTagIds.push(tag.id);
                    return [4 /*yield*/, editTag(tagToEdit)];
                case 5:
                    _f.sent();
                    _f.label = 6;
                case 6:
                    index++;
                    return [3 /*break*/, 4];
                case 7:
                    index = 0;
                    _f.label = 8;
                case 8:
                    if (!(index < initialReverseConnectedTagIds.length)) return [3 /*break*/, 11];
                    idToEdit = initialReverseConnectedTagIds[index];
                    if (!!reverseConnectedTagIds.includes(idToEdit)) return [3 /*break*/, 10];
                    tagToEdit = tagData.tagById[idToEdit];
                    tagToEdit.connectedTagIds = tagToEdit.connectedTagIds.filter(function (id) { return id !== tag.id; });
                    return [4 /*yield*/, editTag(tagToEdit)];
                case 9:
                    _f.sent();
                    _f.label = 10;
                case 10:
                    index++;
                    return [3 /*break*/, 8];
                case 11:
                    if (!(_tag.type === TagType.Dimension)) return [3 /*break*/, 13];
                    return [4 /*yield*/, updateDimConnections()];
                case 12:
                    _f.sent();
                    _f.label = 13;
                case 13:
                    setLoading(false);
                    Manager.closeModal();
                    return [3 /*break*/, 15];
                case 14:
                    err_1 = _f.sent();
                    setLoading(false);
                    invalidErr = { generalErr: err_1.message ? err_1.message : L('Failed to save changes.') };
                    setInvalid(invalidErr);
                    return [3 /*break*/, 15];
                case 15: return [3 /*break*/, 17];
                case 16:
                    setInvalid(invalid);
                    _f.label = 17;
                case 17: return [2 /*return*/];
            }
        });
    }); };
    var validate = function (tag) { return __awaiter(void 0, void 0, void 0, function () {
        var invalid, existingTag, _a, tokens, errors, allowedFuncs_1, find, compilationErrors, e_2;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    invalid = {};
                    if (!tag.id) {
                        existingTag = tagData.getTagByNameAndParent(tag.name, tag.ParentId);
                        if (existingTag) {
                            invalid.name = L('Tag name already exists.');
                        }
                    }
                    if (tag.type === null || tag.type === undefined) {
                        invalid.type = L('You must choose a type');
                    }
                    if (tag.name === '') {
                        invalid.name = L('You must enter a name for the tag');
                    }
                    else if (tag.name.includes('"')) {
                        invalid.name = L("Tag name can't contain quotation marks.");
                    }
                    if (((_b = tag.numberFormat) === null || _b === void 0 ? void 0 : _b.format) && !isValidFormat(tag.numberFormat.format)) {
                        invalid.format = L('Invalid variable tag format: ' + tag.numberFormat.format);
                    }
                    if (!tag.expression) return [3 /*break*/, 4];
                    _a = checkExpression(tag.expression, tagData, sheetRowsById), tokens = _a.tokens, errors = _a.errors;
                    if (tag.type === TagType.Dimension) {
                        allowedFuncs_1 = ['and', 'or', 'not'];
                        find = tokens.find(function (token) {
                            return token.tokenAnnotationType === 'function' && !allowedFuncs_1.includes(token.image);
                        });
                        if (find) {
                            invalid.expression = "".concat(L('Function'), " \"").concat(find.image, "\" ").concat(L('is not allowed on dimension tags.'));
                            return [2 /*return*/, invalid];
                        }
                    }
                    if (errors && errors.length > 0) {
                        invalid.expression = getExpErrorString(errors[0], L);
                        return [2 /*return*/, invalid];
                    }
                    if (!(tag.type === TagType.Dimension || tag.type === TagType.Account)) return [3 /*break*/, 4];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, validateExpression(tag.type === TagType.Dimension ? ExpressionType.Dimension : ExpressionType.Account, tag.expression)];
                case 2:
                    compilationErrors = _c.sent();
                    if (compilationErrors.length > 0) {
                        invalid.expression = getExpErrorString(compilationErrors[0], L);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _c.sent();
                    invalid.expression = L('Invalid formula.');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, invalid];
            }
        });
    }); };
    var handleChange = function (e) {
        var _a;
        var category = e.target.name;
        var _tag = __assign({}, tag);
        switch (category) {
            case 'formatType':
                if (e.target.value === null) {
                    _tag.numberFormat = null;
                }
                else if (e.target.value !== formatType) {
                    _tag.numberFormat = {
                        type: e.target.value,
                        format: (_a = PREDEFINED_FORMATS[e.target.value]) === null || _a === void 0 ? void 0 : _a[0],
                    };
                }
                setFormatType(e.target.value);
                break;
            case 'numberFormat':
                _tag.numberFormat = __assign(__assign({}, _tag.numberFormat), { format: e.target.value });
                break;
            default:
                _tag[e.target.name] = e.target.value;
                break;
        }
        setTag(_tag);
    };
    var changeParent = function (tagId) {
        var editedTag = __assign({}, tag);
        editedTag.ParentId = tagId;
        setTag(editedTag);
    };
    function handleConnectionWarnings(accTag) {
        var e_3, _a;
        var diffDimAccTags = getConnectedAccTagsWithDiffDimensions(accTag, { tagMap: tagData.tagById });
        var dimensionsByTableTagId = getFixatedTagsConnectedToDimensionsMap(accTag, {
            tagMap: tagData.tagById,
            relationMap: tagData.relationsByTableTagId,
        });
        if (dimensionsByTableTagId) {
            try {
                for (var _b = __values(dimensionsByTableTagId.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), tableTagId = _d[0], dimensionTags_1 = _d[1];
                    var tableTag = tagData.tagById[tableTagId];
                    if (!tableTag) {
                        continue;
                    }
                    warning("Be careful. Set dimension table \"".concat(tableTag.name, "\" for variable \"").concat(accTag.name, "\"  is connected or contains fixated tag/s ").concat(dimensionTags_1
                        .map(function (dt) { return '"' + dt.name + '"'; })
                        .join(','), ". This could lead to unexpected behaviour."));
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        if (diffDimAccTags) {
            warning("Be careful. Connected variable tag/s ".concat(diffDimAccTags
                .map(function (t) { return '"' + t.name + '"'; })
                .join(','), " has/have different dimensions than variable \"").concat(accTag.name, "\". This will affect calculation performance."));
        }
    }
    var updateConnectedTags = function (tagId) {
        var _a;
        var _tag = __assign({}, tag);
        if ((_a = _tag.connectedTagIds) === null || _a === void 0 ? void 0 : _a.includes(tagId)) {
            _tag.connectedTagIds = _tag.connectedTagIds.filter(function (tid) { return tid !== tagId; });
        }
        else {
            _tag.connectedTagIds = __spreadArray(__spreadArray([], __read((_tag.connectedTagIds || [])), false), [tagId], false);
            if (isAccountTag(_tag)) {
                handleConnectionWarnings(_tag);
            }
        }
        setTag(_tag);
    };
    var updateReverseConnectedTags = function (tagId) {
        var newrctIds = __spreadArray([], __read(reverseConnectedTagIds), false);
        if (newrctIds.includes(tagId)) {
            newrctIds = newrctIds.filter(function (rctId) { return rctId !== tagId; });
        }
        else {
            newrctIds.push(tagId);
            var reverseConnectedTag = tagData.tagById[tagId];
            if (isAccountTag(reverseConnectedTag)) {
                // Fake connection on reverse connected tag
                reverseConnectedTag = __assign({}, reverseConnectedTag);
                reverseConnectedTag.connectedTagIds = __spreadArray(__spreadArray([], __read((reverseConnectedTag.connectedTagIds || [])), false), [tag.id], false);
                handleConnectionWarnings(reverseConnectedTag);
            }
        }
        setReverseConnectedTagIds(newrctIds);
    };
    var updateDimensionTags = function (tagId) {
        var _a, _b;
        var _tag = __assign({}, tag);
        if ((_a = _tag.dimensionTagIds) === null || _a === void 0 ? void 0 : _a.includes(tagId)) {
            _tag.dimensionTagIds = _tag.dimensionTagIds.filter(function (tid) { return tid !== tagId; });
        }
        else {
            _tag.dimensionTagIds = __spreadArray(__spreadArray([], __read(((_b = _tag.dimensionTagIds) !== null && _b !== void 0 ? _b : [])), false), [tagId], false);
        }
        setTag(_tag);
    };
    var updateConnectedTagsWithNewArray = function (connTags) {
        var _tag = __assign({}, tag);
        _tag.connectedTags = __spreadArray([], __read(connTags), false);
        setTag(_tag);
    };
    var doTopDown = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (!tag.id) return [3 /*break*/, 2];
                    startGlobalLoading();
                    return [4 /*yield*/, backpropApi.backprop({ tagId: tag.id })];
                case 1:
                    _a.sent();
                    stopGlobalLoading();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var updateDimConnectedTags = function (tagId) {
        var ids = __spreadArray([], __read(dimConnTags), false);
        if (ids.includes(tagId)) {
            ids = ids.filter(function (tid) { return tid !== tagId; });
        }
        else {
            ids.push(tagId);
        }
        setDimConnTags(ids);
    };
    var updateDimReverseConnectedTags = function (tagId) {
        var ids = __spreadArray([], __read(dimReverseConnTags), false);
        if (ids.includes(tagId)) {
            ids = ids.filter(function (tid) { return tid !== tagId; });
        }
        else {
            ids.push(tagId);
        }
        setDimReverseConnTags(ids);
    };
    var dimConnectedTags = useMemo(function () {
        var arr = [];
        dimConnTags.forEach(function (tagId) {
            var t = tagData.tagById[tagId];
            if (t) {
                arr.push(t);
            }
        });
        return arr;
    }, [dimConnTags]);
    var dimReverseConnectedTags = useMemo(function () {
        var arr = [];
        dimReverseConnTags.forEach(function (tagId) {
            var t = tagData.tagById[tagId];
            if (t) {
                arr.push(t);
            }
        });
        return arr;
    }, [dimReverseConnTags]);
    var dimFilterByParentId = (relations || []).map(function (relation) { return relation.connectedTableTagId; });
    var dimReverseFilterByParentId = (reverseRelations || []).map(function (relation) { return relation.tableTagId; });
    var disabledTagIds = React.useMemo(function () {
        var disabled = [];
        if (tag.id) {
            disabled.push(tag.id);
        }
        // create parent tag options:
        var addChildren = function (childTags) {
            childTags.forEach(function (childTag) {
                disabled.push(childTag.id);
                var childTagChildTags = tagData.tagsByParentId[childTag.id];
                if (childTagChildTags) {
                    addChildren(childTagChildTags);
                }
            });
        };
        var children = tagData.tagsByParentId[String(tag.id)];
        if (children)
            addChildren(children);
        return disabled;
    }, [tag.id, tag.ParentId]);
    var ParentId = tag.ParentId === null ? -1 : tag.ParentId;
    var connectedTags = [];
    (_e = tag.connectedTagIds) === null || _e === void 0 ? void 0 : _e.forEach(function (id) {
        var t = tagData.tagById[id];
        if (t) {
            connectedTags.push(t);
        }
    });
    var dimensionTags = [];
    (_f = tag.dimensionTagIds) === null || _f === void 0 ? void 0 : _f.forEach(function (id) {
        var t = tagData.tagById[id];
        if (t) {
            dimensionTags.push(t);
        }
    });
    var filteredSearchables = useMemo(function () {
        if (tag.type === TagType.Dimension) {
            return searchables.filter(function (searchable) {
                if (searchable.blockType !== ExpressionBlockTypes.FUNCTION ||
                    (searchable.blockType === ExpressionBlockTypes.FUNCTION &&
                        ['or', 'and', 'not'].includes(searchable.title))) {
                    return searchable;
                }
            });
        }
        return searchables;
    }, [searchables, tag]);
    var reverseTags = [];
    reverseConnectedTagIds.forEach(function (id) {
        var t = tagData.tagById[id];
        if (t) {
            reverseTags.push(t);
        }
    });
    var filterByTypes = [];
    if (tag.type === TagType.Account) {
        filterByTypes = [TagType.Group];
    }
    else if (tag.type === TagType.Dimension) {
        filterByTypes = [TagType.Table];
    }
    var accountTagTo = tagData.tagById[(_g = tag.toAccountTagId) !== null && _g !== void 0 ? _g : 0];
    var versionTagFrom = tagData.tagById[(_h = tag.fromVersionTagId) !== null && _h !== void 0 ? _h : 0];
    var versionTagTo = tagData.tagById[(_j = tag.toVersionTagId) !== null && _j !== void 0 ? _j : 0];
    var tagTypeName = editingTag ? getTagTypeName(editingTag) : '';
    var title = props.tag ? "".concat(L('Edit ' + tagTypeName), " \"").concat(props.tag.name, "\"") : L('Create Database Object');
    return (React.createElement(Modal, { height: "auto", width: "700" },
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", { className: "form-horizontal", onSubmit: done },
                React.createElement(TextInput, { label: L('Name'), value: tag.name, name: "name", onChange: handleChange, invalidString: invalid.name, bottomMargin: true }),
                React.createElement(TextArea, { label: L('Description'), value: tag.description || '', name: "description", onChange: handleChange, bottomMargin: true }),
                !simpleMode && (React.createElement(React.Fragment, null,
                    tag.type !== TagType.Dimension && (React.createElement(SelectTag, { name: "ParentId", disabledTagIds: disabledTagIds, selectedTagId: ParentId, label: L('Parent'), nullLabel: L('Root'), placeholder: L('Search or select parent tag'), onChange: changeParent, filterByTypes: filterByTypes, bottomMargin: true })),
                    tag.type === TagType.Account && (React.createElement(React.Fragment, null,
                        React.createElement(FormField, { "$bottomSpace": true },
                            React.createElement(SelectInput, { name: "rollupType", value: tag.rollupType, label: L('Rollup type'), onChange: handleChange, options: ROLLUP_TYPES, bottomMargin: true })),
                        React.createElement(FormField, { "$bottomSpace": true },
                            React.createElement(SelectInput, { name: "dataType", value: (_k = tag === null || tag === void 0 ? void 0 : tag.dataType) !== null && _k !== void 0 ? _k : DataType.Decimal, label: L('Data type'), onChange: handleChange, options: DATA_TYPE_OPTIONS, bottomMargin: true })),
                        React.createElement(FormField, { "$bottomSpace": true },
                            React.createElement(SelectInput, { name: "formatType", value: formatType !== null && formatType !== void 0 ? formatType : null, label: L('Format type'), onChange: handleChange, options: FORMAT_OPTIONS, bottomMargin: true })),
                        formatType && formatType !== DefaultFormatType.Custom ? (React.createElement(FormField, { "$bottomSpace": true },
                            React.createElement(SelectInput, { name: "numberFormat", value: ((_l = tag.numberFormat) === null || _l === void 0 ? void 0 : _l.type) === formatType
                                    ? tag.numberFormat.format
                                    : (_m = PREDEFINED_FORMATS === null || PREDEFINED_FORMATS === void 0 ? void 0 : PREDEFINED_FORMATS[formatType]) === null || _m === void 0 ? void 0 : _m[0], label: L('Choose formating option'), onChange: handleChange, options: PREDEFINED_FORMATS[formatType].map(function (f) { return ({
                                    value: f,
                                    label: "".concat(isExcelDateFormat(f)
                                        ? excelLocalizedDateFormat(new Date(), f)
                                        : isExcelPercentFormat(f)
                                            ? "Positive: ".concat(excelLocalizedNumberFormat(0.15, f), " Negative: ").concat(excelLocalizedNumberFormat(-0.15, f))
                                            : "Positive: ".concat(excelLocalizedNumberFormat(15000, f), " Negative: ").concat(excelLocalizedNumberFormat(-15000, f)), " Format: ").concat(f),
                                }); }), bottomMargin: true }))) : null,
                        formatType === DefaultFormatType.Custom ? (React.createElement(TextInput, { name: "numberFormat", value: (_p = (_o = tag === null || tag === void 0 ? void 0 : tag.numberFormat) === null || _o === void 0 ? void 0 : _o.format) !== null && _p !== void 0 ? _p : '', onChange: handleChange, label: L('Enter custom format'), bottomMargin: true, invalid: !!invalid.format, invalidString: invalid.format })) : null)),
                    (tag.type === TagType.Account || tag.type === TagType.Dimension) && (React.createElement(FormField, { "$bottomSpace": true },
                        React.createElement(FormFieldLabel, null, L('Formula')),
                        React.createElement(ExpEditor, { ref: expRef, style: { width: '100%' }, expression: (_q = tag.expression) !== null && _q !== void 0 ? _q : '', searchables: filteredSearchables }),
                        invalid.expression && (React.createElement(FormFieldErrorHelp, null, invalid.expression)))),
                    tag.type === TagType.Account && (React.createElement(React.Fragment, null,
                        React.createElement(FormField, null,
                            React.createElement(CheckBox, { action: function () { return setTag(__assign(__assign({}, tag), { topDownEnabled: !tag.topDownEnabled })); }, checked: tag.topDownEnabled, label: L('Top down enabled') })),
                        tag.topDownEnabled && (React.createElement(React.Fragment, null,
                            React.createElement(FormField, { "$bottomSpace": true },
                                React.createElement(FSButton, { title: L('Top down'), icon: FiRefreshCcw, "$type": "secondary", onClick: doTopDown })),
                            React.createElement(FormField, { "$bottomSpace": true },
                                React.createElement(FormFieldLabel, { "$bottomSpace": true }, L('Top down data mapping')),
                                React.createElement(ExpEditor, { ref: topDownMappingRef, style: { width: '100%', flexGrow: 1 }, expression: (_r = tag.topDownMapping) !== null && _r !== void 0 ? _r : '', searchables: filteredSearchables }),
                                invalid.topDownMapping ? (React.createElement(FormFieldErrorHelp, null, invalid.topDownMapping)) : null))))))),
                tag.type === TagType.Account && (React.createElement(React.Fragment, null,
                    React.createElement(FormFieldLabel, null, L('Connected')),
                    simpleMode ? (React.createElement(TagsEditWithDropdown, { tags: connectedTags, updateConnectedTagsWithNewArray: updateConnectedTagsWithNewArray })) : (React.createElement("div", { style: { marginBottom: 10 } },
                        React.createElement(Tags, { canUpdate: true, tags: connectedTags, remove: updateConnectedTags, select: updateConnectedTags, placeholder: L('Add connected variable'), filterByTypes: [TagType.Account] }))),
                    !simpleMode && (React.createElement(React.Fragment, null,
                        React.createElement(FormFieldLabel, null, L('Reverse connected')),
                        React.createElement("div", { style: { marginBottom: 10 } },
                            React.createElement(Tags, { canUpdate: true, tags: reverseTags, remove: updateReverseConnectedTags, select: updateReverseConnectedTags, placeholder: L('Add reverse connected variable'), filterByTypes: [TagType.Account] })))),
                    React.createElement(FormFieldLabel, null, L('Dimensions')),
                    React.createElement("div", { style: { marginBottom: 10 } },
                        React.createElement(Tags, { canUpdate: true, tags: dimensionTags, remove: updateDimensionTags, select: updateDimensionTags, placeholder: L('Add dimension'), filterByTypes: [TagType.Table, TagType.Dimension] })))),
                tag.type === TagType.Account && (React.createElement(React.Fragment, null,
                    React.createElement(FSFormSection, { show: showAdvanced, title: L('Advanced'), onClick: function () { return setShowAdvanced(!showAdvanced); }, style: { marginTop: 15, marginBottom: 5 } },
                        React.createElement(FormField, null,
                            React.createElement(CheckBox, { action: function () { return setTag(__assign(__assign({}, tag), { readonly: !tag.readonly })); }, checked: tag.readonly, label: L('Readonly') })),
                        React.createElement(FormField, null,
                            React.createElement(CheckBox, { action: function () { return setTag(__assign(__assign({}, tag), { calculateOnDemand: !tag.calculateOnDemand })); }, checked: tag.calculateOnDemand, label: L('Calculate on demand') }),
                            !!tag.calculateOnDemand && (React.createElement("small", { style: { opacity: 0.8 } }, L('To trigger On-Demand calculation, go to "Input Setup"')))),
                        React.createElement(FormField, null,
                            React.createElement(CheckBox, { action: function () { return setTag(__assign(__assign({}, tag), { optimizeCalculation: !tag.optimizeCalculation })); }, checked: tag.optimizeCalculation, label: L('Optimize calculation') })),
                        React.createElement(FormField, null,
                            React.createElement(CheckBox, { action: function () { return setTag(__assign(__assign({}, tag), { zConstraint: !tag.zConstraint })); }, checked: tag.zConstraint, label: L('Constrained light top down') })),
                        React.createElement(FormFieldLabel, null, L('Mapping to Variable')),
                        React.createElement("div", { style: { marginBottom: 10 } },
                            React.createElement(Tags, { canUpdate: true, tags: accountTagTo ? [accountTagTo] : [], remove: function () {
                                    setTag(__assign(__assign({}, tag), { toAccountTagId: null }));
                                }, select: function (tagId) {
                                    setTag(__assign(__assign({}, tag), { toAccountTagId: tagId }));
                                }, placeholder: L('Add from Version'), hideAddButton: !!accountTagTo, filterByTypes: [TagType.Account] })),
                        React.createElement(FormFieldLabel, null, L('Mapping from Version')),
                        React.createElement("div", { style: { marginBottom: 10 } },
                            React.createElement(Tags, { canUpdate: true, tags: versionTagFrom ? [versionTagFrom] : [], remove: function () {
                                    setTag(__assign(__assign({}, tag), { fromVersionTagId: null }));
                                }, select: function (tagId) {
                                    setTag(__assign(__assign({}, tag), { fromVersionTagId: tagId }));
                                }, placeholder: L('Add from Version'), hideAddButton: !!versionTagFrom, filterByInternalTypes: [InternalTagType.Version] })),
                        React.createElement(FormFieldLabel, null, L('Mapping to Version')),
                        React.createElement("div", { style: { marginBottom: 10 } },
                            React.createElement(Tags, { canUpdate: true, tags: versionTagTo ? [versionTagTo] : [], remove: function () {
                                    setTag(__assign(__assign({}, tag), { toVersionTagId: null }));
                                }, select: function (tagId) {
                                    setTag(__assign(__assign({}, tag), { toVersionTagId: tagId }));
                                }, placeholder: L('Add to Version'), hideAddButton: !!versionTagTo, filterByInternalTypes: [InternalTagType.Version] })),
                        React.createElement(FSButton, { title: "Export", onClick: onExportClick, type: "button" })),
                    !!((_s = tag.usedInTagIds) === null || _s === void 0 ? void 0 : _s.length) && (React.createElement(React.Fragment, null,
                        React.createElement(FSFormSection, { title: L('Used in ' +
                                tag.usedInTagIds.length +
                                (tag.usedInTagIds.length > 1 ? ' Formulae' : ' Formula')), show: showExpressions, style: { marginTop: 15, marginBottom: 5 }, onClick: function () { return setShowExpressions(!showExpressions); } }, (_u = (_t = tag.usedInTagIds) === null || _t === void 0 ? void 0 : _t.filter(function (t) { return !!tagData.tagById[t]; })) === null || _u === void 0 ? void 0 : _u.map(function (t) {
                            var _a;
                            var tag = tagData.tagById[t];
                            return (React.createElement("div", { key: t, style: {
                                    display: 'flex',
                                    textAlign: 'center',
                                    marginBottom: 5,
                                    width: '100%',
                                } },
                                React.createElement(Tag, { canUpdate: false, tag: tag, style: {
                                        flexShrink: 1,
                                        marginRight: 10,
                                    } }),
                                ' = ',
                                React.createElement("div", { style: {
                                        flexShrink: 1,
                                        marginLeft: 10,
                                        overflowWrap: 'break-word',
                                        overflow: 'hidden',
                                    } },
                                    React.createElement(Editor, { editorState: getEditorState((_a = tag === null || tag === void 0 ? void 0 : tag.expression) !== null && _a !== void 0 ? _a : '', tagData, sheetRowsById), readOnly: true, onChange: function () { } }))));
                        })))))),
                tag.type === TagType.Dimension && (React.createElement(React.Fragment, null,
                    React.createElement("div", { style: { marginBottom: 10 } },
                        React.createElement(FormField, null,
                            React.createElement(CheckBox, { action: function () { return setTag(__assign(__assign({}, tag), { active: !tag.active })); }, checked: tag.active, label: L('Active') }))),
                    dimFilterByParentId.length > 0 && (React.createElement("div", { style: { marginBottom: 10 } },
                        React.createElement(FormFieldLabel, null, L('Connected')),
                        React.createElement(Tags, { canUpdate: true, filterByParentIds: dimFilterByParentId, tags: dimConnectedTags, remove: updateDimConnectedTags, select: updateDimConnectedTags, placeholder: L('Add connected dimension'), filterByTypes: [TagType.Dimension] }))),
                    dimReverseFilterByParentId.length > 0 && (React.createElement("div", { style: { marginBottom: 10 } },
                        React.createElement(FormFieldLabel, null, L('Reverse connected')),
                        React.createElement(Tags, { canUpdate: true, filterByParentIds: dimReverseFilterByParentId, tags: dimReverseConnectedTags, remove: updateDimReverseConnectedTags, select: updateDimReverseConnectedTags, placeholder: L('Add reverse connected dimension'), filterByTypes: [TagType.Dimension] }))))),
                invalid.generalErr && React.createElement(FormFieldErrorHelp, { "$center": true }, invalid.generalErr))),
        React.createElement(ModalFooter, { loading: loading, done: done })));
};
function Mappings(props) {
    var L = useLanguage().L;
    var mappings = props.mappings, mappingOptions = props.mappingOptions, changeHandler = props.changeHandler, removeHandler = props.removeHandler, addHandler = props.addHandler;
    var allOptions = mappingOptions.reduce(function (all, mo) { return all.concat(mo); }, []);
    var valueIndexMap = mappingOptions.reduce(function (valueIndexMap, mo, idx) {
        mo === null || mo === void 0 ? void 0 : mo.forEach(function (mo) { return (valueIndexMap[mo.value] = idx); });
        return valueIndexMap;
    }, {});
    function changeHandlerAdapter(e) {
        var _a = __read(e.target.name.split('-').map(Number), 2), mappingIdx = _a[0], valueIdx = _a[1];
        changeHandler === null || changeHandler === void 0 ? void 0 : changeHandler({ mappingIdx: mappingIdx, valueIdx: valueIdx, value: e.target.value });
    }
    var mappingItems = mappings === null || mappings === void 0 ? void 0 : mappings.map(function (_a, idx) {
        var _b, _c;
        var _d = __read(_a, 2), from = _d[0], to = _d[1];
        var toOptions = from ? (_b = mappingOptions[valueIndexMap[from]]) !== null && _b !== void 0 ? _b : [] : [];
        var filteredToOptions = (_c = toOptions === null || toOptions === void 0 ? void 0 : toOptions.filter(function (_a) {
            var value = _a.value;
            return value !== from &&
                !mappings.some(function (_a, mIdx) {
                    var _b = __read(_a, 2), f = _b[0], t = _b[1];
                    return ((f === from && t === value) || (f === value && t === from)) && mIdx !== idx;
                });
        })) !== null && _c !== void 0 ? _c : [];
        return (React.createElement(TemplatedGrid, { style: {
                marginBottom: '5px',
                alignItems: 'center',
            }, "$colTemplate": '0.1fr 2fr 0.1fr 2fr 1fr', key: from && to ? "".concat(from, "-").concat(to) : idx },
            React.createElement(FormFieldLabel, null,
                L('From'),
                ":"),
            React.createElement(SelectInput, { key: "".concat(idx, "-0"), name: "".concat(idx, "-0"), searchable: true, placeholder: "Select from mapping tag", options: allOptions, value: from, onChange: changeHandlerAdapter }),
            React.createElement(FormFieldLabel, null,
                L('To'),
                ":"),
            React.createElement(SelectInput, { key: "".concat(idx, "-1"), name: "".concat(idx, "-1"), searchable: true, placeholder: from ? 'Select to mapping tag' : '', disabled: !from, options: filteredToOptions, value: to, onChange: changeHandlerAdapter }),
            React.createElement(MdRemove, { color: Color.RED, size: 22, cursor: "pointer", onClick: function () { return removeHandler === null || removeHandler === void 0 ? void 0 : removeHandler(idx); } })));
    });
    var mappingsContainer = mappingItems.length ? (React.createElement(BorderdContainer, { style: { padding: 5 } },
        React.createElement("div", { style: { height: 'auto', maxHeight: 130, overflow: 'auto' } }, mappingItems))) : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(FormField, { "$bottomSpace": true },
            React.createElement(FSButton, { title: "Add mapping", onClick: addHandler, type: "button", disabled: !mappingOptions.length || !mappingOptions.every(function (mo) { return !!(mo === null || mo === void 0 ? void 0 : mo.length); }) })),
        mappingsContainer));
}
export default Wrap;
